/**
 * Module-level PDF brand context, set from AuthProvider so every export
 * can render company header without each page threading props.
 */
let currentBrand = null;

export function resolvePdfCompany({ company, distributor, business } = {}) {
    const src = company || distributor || business || {};
    if (!src?.name && !company && !distributor && !business) {
        return null;
    }
    return {
        _id: src._id || src.id,
        name: src.name || 'Your Business',
        address: src.address || '',
        phone: src.phone || '',
        email: src.email || '',
        ntn: src.ntn || src.taxInfo?.ntn || src.taxId || '',
        taxId: src.taxId || src.ntn || src.taxInfo?.ntn || '',
        registrationNumber: src.registrationNumber || '',
        logo: src.logo || null,
        documentPrintSettings: src.documentPrintSettings || null,
    };
}

export function setPdfBrand(brand) {
    currentBrand = brand && brand.name ? brand : null;
}

export function getPdfBrand() {
    return currentBrand;
}
